/*
 * @Author: 汪永康 wangyongkang@yxj.org.cn
 * @Date: 2024-08-19 15:21:11
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2024-11-20 16:34:44
 * @FilePath: \h5-lcjc-formula\src\utils\category\Urology.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 泌尿外科 */

/** 对应的标题 */
const categoryMap = {
  LocalizedProstateCancer: '局限性前列腺癌风险分级',
  BladderCancer_TNM: '膀胱癌TNM分期（第八版）',
  BladderUrothelialCarcinoma: '膀胱尿路上皮癌恶性程度分级系统',
  UrethralTumor_TNM: '尿道肿瘤TNM分期',
  GFR_CKD_EPI: 'GFR（CKD-EPI）',
  StagingOfDiaNep: '糖尿病肾病分期',
  Luteinizing_Hormone: '黄体生成素（LH）',
  Testosterone: '睾酮',
  a1_Microglobulin: 'α1-微球蛋白',
  Beta_2_Microglobulin: 'β2-微球蛋白(β2-M)',
  Free_PSA: '游离前列腺特异性抗原'
}
/** 对应的描述 */
const categoryDescMap = {
  LocalizedProstateCancer: '评价局限性前列腺癌预后',
  BladderCancer_TNM: '评估膀胱癌病情进展',
  BladderUrothelialCarcinoma: '',
  UrethralTumor_TNM: '评估尿道肿瘤患者病情进展',
  GFR_CKD_EPI: '肾小球滤过率',
  StagingOfDiaNep: '评估糖尿病肾病严重程度'
}
export default {
  categoryMap,
  categoryDescMap
}



// WEBPACK FOOTER //
// ./src/utils/category/Urology.js